export const cardArray = [
  {
    name: 'cage1',
    img: '/images/cagematch/cage1.jpg',
  },
  {
    name: 'cage2',
    img: '/images/cagematch/cage2.jpg',
  },
  {
    name: 'cage3',
    img: '/images/cagematch/cage3.jpg',
  },
  {
    name: 'cage4',
    img: '/images/cagematch/cage4.jpg',
  },
  {
    name: 'cage5',
    img: '/images/cagematch/cage5.jpg',
  },
  {
    name: 'cage7',
    img: '/images/cagematch/cage7.jpg',
  },
  {
    name: 'cage8',
    img: '/images/cagematch/cage8.jpg',
  },
  {
    name: 'cage9',
    img: '/images/cagematch/cage9.jpg',
  },
  {
    name: 'cage11',
    img: '/images/cagematch/cage11.jpg',
  },
  {
    name: 'cage12',
    img: '/images/cagematch/cage12.jpg',
  },
  {
    name: 'cage13',
    img: '/images/cagematch/cage13.jpg',
  },
  {
    name: 'cage14',
    img: '/images/cagematch/cage14.jpg',
  },
  {
    name: 'cage15',
    img: '/images/cagematch/cage15.jpg',
  },
  {
    name: 'cage16',
    img: '/images/cagematch/cage16.jpg',
  },
  {
    name: 'cage17',
    img: '/images/cagematch/cage17.jpg',
  },
];
